<p class="soft-text ml-2 mr-2">Die angezeigte Legierung wird als Späne ausgebucht. Wollen Sie fortfahren?</p>

<div class="c center pt-2 pb-2 min-h" *ngIf="loading(); else itemsTemplate">
  <soft-loading-spinner class="spin"></soft-loading-spinner>
</div>

<ng-template #itemsTemplate>
  <div class="c column ml-2 mr-2 border-box mt-2" *ngIf="lighterMaterials() as lighterMaterials">
    <ng-container *ngIf="((lighterMaterials?.length ?? 0) > 0); else noResult">
      <div (click)="selectedMaterial.set(item)" *ngFor="let item of lighterMaterials; let last = last" [class.border-b]="!last" [ngClass]="selectedMaterial()?.cartikelnummer === item?.cartikelnummer ? 'bg-selected' : 'bg-surface'" class="c pt-2 pb-2 column center-v">
        <div class="c row space-between no-wrap center-v">
          <div class="c column">
            <span class="soft-overline" *ngIf="item?.cartikelnummer">{{ item?.cartikelnummer }}</span>
            <strong class="soft-text-l">{{ item?.bezeichnung || '-' }}</strong>
            <span class="soft-text" *ngIf="item?.legierung">{{ item?.legierung }}</span>
          </div>
          <span class="mr-3" style="font-weight: bold; font-size: 1.25rem" *ngIf="item?.gewicht">{{ (item?.gewicht || 0) | number:'1.3-3' }}g</span>
        </div>
      </div>
    </ng-container>
    <ng-template #noResult>
      <div style="min-height: 70px" class="c row center">
        Keine Späne gefunden!
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-container *ngIf="lighterMaterials() as lighterMaterials">
  <div class="c row no-wrap">
    <button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
    <button class="soft-button primary custom mt-3" (click)="close(selectedMaterial())" [disabled]="(lighterMaterials?.length ?? 0) < 1 || !selectedMaterial()">Fortfahren</button>
  </div>
</ng-container>


